export const ALL_USER_ICONS = [
  "MdFitnessCenter",
  "MdConfirmationNumber",
  "MdDiamond",
  "MdHeadphones",
  "MdRealEstateAgent",
  "MdWeb",
  "MdDirections",
  "MdCake",
  "MdCottage",
  "MdCorporateFare",
  "MdSelfImprovement",
  "MdWallet",
  "MdSubscriptions",
  "MdBed",
  "MdVaccines",
  "MdCompost",
  "MdChair",
  "MdLan",
  "MdNature",
  "MdPeople",
  "MdAir",
  "MdHotel",
  "MdBatteryFull",
  "MdNavigation",
  "MdWarehouse",
  "MdLandscape",
  "MdHiking",
  "MdBeachAccess",
  "MdWatch",
  "MdWoman",
  "MdBusiness",
  "MdPark",
  "MdLocalGasStation",
  "MdArchitecture",
  "MdCheckroom",
  "MdCardMembership",
  "MdSolarPower",
  "MdLuggage",
  "MdGrass",
  "MdShower",
  "MdAgriculture",
  "MdSportsBaseball",
  "MdSportsFootball",
  "MdSportsBar",
  "MdSailing",
  "MdFax",
  "MdWindPower",
  "MdElderly",
  "MdElderlyWoman",
  "MdLocalDrink",
  "MdYard",
  "MdWineBar",
  "MdGames",
  "MdGamepad",
  "MdElectricCar",
  "MdRamenDining",
  "MdChurch",
  "MdNightlife",
  "MdSick",
  "MdCookie",
  "MdGarage",
  "MdSportsGymnastics",
  "MdSurfing",
  "MdSportsMotorsports",
  "MdMuseum",
  "MdApartment",
  "MdWork",
  "MdInventory2",
  "MdWifi",
  "MdRocket",
  "MdLightbulb",
  "MdCarRental",
  "MdCamera",
  "MdCampaign",
  "MdRestaurant",
  "MdPrint",
  "MdPsychology",
  "MdVolunteerActivism",
  "MdPalette",
  "MdPallet",
  "MdMusicNote",
  "MdVideocam",
  "MdWaterDrop",
  "MdChecklist",
  "MdAdsClick",
  "MdMood",
  "MdCloud",
  "MdHealthAndSafety",
  "MdEmail",
  "MdBook",
  "MdSchool",
  "MdBikeScooter",
  "MdPedalBike",
  "MdElectricBike",
  "MdKeyboard",
  "MdLaptop",
  "MdBusAlert",
  "MdFireTruck",
  "MdSmartphone",
  "MdSmartScreen",
  "MdFastfood",
  "MdFemale",
  "MdMale",
  "MdFactory",
  "MdBuild",
  "MdFlight",
  "MdForest",
  "MdTwoWheeler",
  "MdAirplaneTicket",
  "MdConstruction",
  "MdHandyman",
  "MdPlumbing",
  "MdRoomService",
  "MdMedicalServices",
  "MdCleaningServices",
  "MdHomeRepairService",
  "MdDesignServices",
  "MdMiscellaneousServices",
  "MdElectricalServices",
  "MdLocalLaundryService",
  "MdLocalGroceryStore",
  "MdWater",
  "MdTravelExplore",
  "MdShop",
  "MdDevices",
  "MdLocalPizza",
  "MdIcecream",
  "MdBakeryDining",
  "MdKitchen",
  "MdEgg",
  "MdHolidayVillage",
  "MdCategory",
  "MdCoffee",
  "MdCoffeeMaker",
  "MdFoodBank",
  "MdFace",
  "MdFace2",
  "MdFac3",
  "MdFace4",
  "MdFace5",
  "MdFace6",
  "MdHome",
  "MdFavorite",
  "MdCarRepair",
  "MdPhone",
  "MdStar",
  "MdAttachMoney",
  "MdOutlineCake",
  "MdAirportShuttle",
  "MdAndroid",
  "MdAudiotrack",
  "MdFlag",
  "MdBathtub",
  "MdUmbrella",
  "MdBluetooth",
  "MdSunny",
  "MdSunnySnowing",
  "MdTrain",
  "MdBubbleChart",
  "MdCameraAlt",
  "MdCardGiftcard",
  "MdCasino",
  "MdChildCare",
  "MdColorLens",
  "MdCommute",
  "MdContactless",
  "MdDeck",
  "MdDirectionsBoat",
  "MdFingerprint",
  "MdGavel",
  "MdHealing",
  "MdHeadset",
  "MdHearing",
  "MdKingBed",
  "MdOutlineLandscape",
  "MdLocalCarWash",
  "MdOutlineLocalDrink",
  "MdOutlineLocalPizza",
  "MdLocalPolice",
  "MdOutdoorGrill",
  "MdOutlinePalette",
  "MdPets",
  "MdPregnantWoman",
  "MdOutlinePrint",
  "MdOutlineSchool",
  "MdRowing",
  "MdScanner",
  "MdShoppingBasket",
  "MdSportsBasketball",
  "MdSportsCricket",
  "MdSportsGolf",
  "MdSportsHandball",
  "MdSportsHockey",
  "MdSportsKabaddi",
  "MdSportsMartialArts",
  "MdSportsMma",
  "MdSportsSoccer",
  "MdSportsScore",
  "MdSportsRugby",
  "MdSportsTennis",
  "MdSportsVolleyball",
  "MdSubway",
];
